import i18next from 'i18next';

i18next.addResources('en', 'AdelphiSpiritMenu', {
  title: 'Spirit Attainment',
  feints: 'Feints',
  spiritReduction: 'Spirit Reduction',
  caskFilling: 'Cask Filling'
});
